"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v5.27.0
// source: v1/cluster-explorer.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteropMessage_Status = void 0;
var InteropMessage_Status;
(function (InteropMessage_Status) {
    InteropMessage_Status["PENDING"] = "PENDING";
    InteropMessage_Status["FAILED"] = "FAILED";
    InteropMessage_Status["SUCCESS"] = "SUCCESS";
    InteropMessage_Status["EXPIRED"] = "EXPIRED";
    InteropMessage_Status["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InteropMessage_Status || (exports.InteropMessage_Status = InteropMessage_Status = {}));
